// Store poem metadata and HTML content here
export const poems = [
    {
      id: "there-you-go-again",
      title: "Oh, there go my thoughts once again",
      author: "ben chesser",
      date: "Spring 2026",
      content: `<pre>Oh, there go my thoughts once again
    the       y
          go                  again
                t        o
              y   ou

                         once    i
                thought
              y   ou
             my
             m     u   s    e

Oh, there     y   ou
          go
                              again</pre>`
    },
    {
      id: "paper-flowers",
      title: "Paper Flowers",
      author: "ben chesser",
      date: "Summer 2025",
      content: `
        <p>after our woods burned<br/>
        your warmth cuts<br/>
        my brain in two halves<br/>
        two thoughts<br/>
        one pure, one absolute</p>

        <p>the latter sees the pattern, the lie<br/>
        confines but comforts<br/>
        the walls suppress contact<br/>
        convince that it was not a painful lesson<br/>
        it was just painful<br/>
        that the woods were left as ash and rubble<br/>
        and only I was charred</p>

        <p>if I destroyed you, do not smile<br/>
        a greeting meant for someone clean<br/>
        enough!<br/>
        the child will take this<br/>
        and run to the high hills<br/>
        see the light and shout from the peaks<br/>
        this is value, this is love<br/>
        I cannot stand to see<br/>
        me like this<br/>
        to kneel at the bleeding boundary<br/>
        trying to cry</p>

        <p>painfully<br/>
        woefully<br/>
        beautifully<br/>
        there is a home for you wherever I am</p>
      `
    },
    {
      id: "other-side",
      title: "the other side of the hill",
      author: "ben chesser",
      date: "Fall 2024",
      content: `
        <p>The dead have never spoken with me.</p>

        <p>I heard the silence, realized<br>
        it's the kind of joke that kills you, that makes you<br>
        swig salt water and wash your eyes out with soap.</p>

        <p>Ripples carry leaves of thought up<br>
        the river to when I was last alone.</p>

        <p>Ivy ties my ankles down–<br>
        The gift of leaving me here to wonder.</p>

        <p>Friendships turn to nothing when left<br>
        alone long enough to see the edges.</p>

        <p>I was boiling over with thought thought<br>
        thought about what did not matter.</p>

        <p>Then I thought I missed my mom. I think<br>
        I saw her crossing the other side of the hill.</p>
      `
    },
    {
      id: "meghan",
      title: "Meghan!",
      author: "ben chesser",
      date: "Fall 2024",
      content: `
        <p>I wish I didn’t like my therapist<br/>
        I want to be the grizzled mobster<br/>
        Serving his court appointed time</p>
        <p>Instead, she says that my vulnerability serves me well<br/>
        Stop it, Meghan!<br/>
        You’re making me blush</p>
        <p>My therapist tells me what I already know and don’t want to hear<br/>
        And I deflect and make jokes<br/>
        That she then quickly scribbles down<br/>
        It’s not that serious, Meghan!</p>
        <p>The first man on mars steps out to see<br/>
        A luxury hotel and spa<br/>
        Free drinks at the open bar<br/>
        And a late check out</p>
        <p>Oh, Meghan!<br/>
        My life is so hard<br/>
        Oh come on, don’t write that down</p>
      `
    },    
    {
      id: "panic",
      title: "Panic",
      author: "ben chesser",
      date: "Fall 2024",
      content: `
        <p>Following episodes of panic,<br/>
        I like to remember its origins.<br/>
        Pan, the Greek god of the wild.<br/>
        Not like Peter Pan,<br/>
        or a boys youthful trouble,<br/>
        But a more external, primal wild.</p>
        <p>The legs and horns of a goat,<br/>
        Pan reminds me of the wild in me.<br/>
        When texts and zoom calls cause panic,<br/>
        I think of my ancestors everyday fight<br/>
        For life in and with nature.<br/>
        Sometimes I yearn for that devolution<br/>
        But panic fades with time.</p>
      `
    },
    {
      id: "pity-of-natural-things",
      title: "the pity of natural things",
      author: "ben chesser",
      date: "Fall 2024",
      content: `
        <p>At the base of the mountain, there lived a miner<br/>
        He wept, for town stopped needing his coal</p>
        <p>The mountain heard cries, taking pity on him<br/>
        and reforged the mine to one of gold</p>
        <p>The man gained the wealth of kings, then took some more<br/>
        and the mountain begged for the mine to close</p>
        <p>But he kept taking and taking, till the mountain gave in<br/>
        Thundering, the man and his town were buried in gold</p>
      `
    },
    {
      id: "realization",
      title: "Realization",
      author: "ben chesser",
      date: "Fall 2023",
      content: `
        <p>As the train wades through the<br/>
        swarming masses, overflowing with<br/>
        spirits, each with their own<br/>
        loves, and the</p>
        <p>girl lay memorizing the<br/>
        ceiling as the faint glow of<br/>
        light and laughter<br/>
        invades her rest, and the</p>
        <p>black cat<br/>
        cowers in a corner,<br/>
        her new owners striking<br/>
        fear with unfamiliar compassion, and the</p>
        <p>piano rings out, a last<br/>
        cry as it's lowered in the<br/>
        depot, longing for its caretaker who’s<br/>
        off to another plane,</p>
        <p>the boy realized;</p>
        <p>it’s easier to want to love than to be in love,<br/>
        and easier to deny it than to let it flourish and infest</p>
      `
    },
    {
      id: "someone-to-watch-over-me",
      title: "Someone to Watch Over Me",
      author: "ben chesser",
      date: "Fall 2023",
      content: `
        <p>There are stills wedged into memory of her<br/>
        sitting on the porch rocking chair next to Ben,<br/>
        my grandfather, watching us children play<br/>
        and fight<br/>
        and cry<br/>
        and live.<br/>
        Besides that, I only remember her nearing<br/>
        the end.</p>
        <p>Weekdays my kind, brave,<br/>
        depressed mom would pick me up from school<br/>
        and we would visit her.<br/>
        Walking down the halls,<br/>
        old,<br/>
        weathered,<br/>
        wise<br/>
        sagging faces would look down at me and smile.</p>
        <p>In a place like this, children were regarded as<br/>
        soldiers home from war. I didn’t smile back. Or I did.<br/>
        I don’t remember.</p>
        <p>My grandmother’s room was not far<br/>
        from the entrance, but it was behind<br/>
        a locked gate because of that time she got out.<br/>
        A nurse might guide us in, but it was<br/>
        worse when we had to go alone. When we opened the door,<br/>
        my grandmother would be<br/>
        watching TV from her bed.<br/>
        She might look up at us.<br/>
        If she did, she would normally smile. She tended to be<br/>
        a very warm woman, but she tended to worry.</p>
        <p>We’d come in and ask how her day had gone<br/>
        and how she was doing<br/>
        and if there was<br/>
        anything we could do to make her<br/>
        more comfortable, and she would say<br/>
        she’s alright, if you could just bring her<br/>
        Ben.</p>
        <p>My mom would get that look in her eye,<br/>
        like she was hoping for something different. She would say<br/>
        well, Ben's right here, he’s your grandson. And my grandmother would smile<br/>
        or laugh and tell her not to be silly, and ask again for<br/>
        her Ben to be brought to her. And my kind,<br/>
        brave, depressed mom would have to explain to her that her Ben<br/>
        could not come, he had died many years ago. And she would try<br/>
        to process this information, but nothing would click. And my mom<br/>
        would try to be patient. Eventually, once my<br/>
        kind, brave, depressed mom built up the courage to<br/>
        ask my grandmother if she knew who she was talking to.</p>
        <p>And my grandma would look at her and smile<br/>
        and then frown and apologize, and my mother would say<br/>
        it’s alright and that she must be tired and that she would<br/>
        let her sleep.</p>
        <p>We would put on one of her dusty,<br/>
        antique,<br/>
        black,<br/>
        heavy<br/>
        Ella Fitzergald records and lay her down and we would go to leave. Sometimes, though, walking out of the room we could hear my grandmother<br/>
        start to hum to the tune.</p>
        <p>My mother would pause, listen for a few seconds,<br/>
        and then close the door.</p>
      `
    }
  ];
